<!--Loader-->
<div *ngIf="isLoading" class="ui active inverted dimmer">
    <div class="ui loader"></div>
</div>

<form autocomplete="nope" #form="ngForm" class="app-grid">
    <ng-container *ngFor="let filter of selectedFilters; let i = index">
        <!-- Categories -->
        <mat-form-field class="columns-3 small-columns-12 select-category">
            <mat-select
                name="category{{ i }}"
                placeholder="{{ 'reporting.custom-reports.selectField' | translate }}"
                [(ngModel)]="filter.selectedCategory"
                [compareWith]="compareWith"
                (selectionChange)="onCategorySelectionChange(filter)"
            >
                <mat-option *ngFor="let category of allFilters" [value]="category"> {{ category.label }} </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Operators -->
        <mat-form-field *ngIf="filter.data.property" class="columns-3 small-columns-12">
            <mat-select
                name="operator{{ i }}"
                [placeholder]="getPlaceholderOperatorOfSelectedCategory(filter)"
                [(ngModel)]="filter.data.operator"
                (selectionChange)="clearValues(filter)"
            >
                <mat-option *ngFor="let operator of getOperatorsOfSelectedCategory(filter)" [value]="operator">
                    {{ filter.selectedCategory.operators[operator] }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Filter options -->
        <ng-container *ngIf="!isOperatorBlank(filter)">
            <!-- Chippable Filter options -->
            <div *ngIf="filter.data.property && !isDateFilter(filter)" class="columns-3 small-columns-12">
                <!--Hidden elm to make chips autocomplete field required-->
                <input
                    name="chipsAutoComplete{{ i }}"
                    type="hidden"
                    [(ngModel)]="filter.data.value[0]"
                    required
                    #chipsAutoComplete="ngModel"
                />

                <!--Chips autocomplete-->
                <ui-chips-autocomplete
                    #filterOptionsAutocomplete
                    id="filterOptionsAutocomplete{{ i }}"
                    [label]="chipsAutoCompleteLabel"
                    [autocompleteItems]="getFilterChips(filter)"
                    [selectedItems]="getSelectedFilterChips(filter)"
                >
                </ui-chips-autocomplete>
                <!--Chips error message-->
                <mat-error *ngIf="form.submitted && chipsAutoComplete.errors?.required">{{
                    'reporting.custom-reports.filterIsRequired' | translate
                }}</mat-error>
            </div>

            <!-- Date picker filter options -->
            <div
                *ngIf="filter.data.property && filter.data.operator && isDateFilter(filter)"
                class="columns-3 small-columns-12"
            >
                <!-- Normal date picker -->
                <mat-form-field style="width: 100%" *ngIf="!isOperatorBetween(filter)">
                    <input
                        matInput
                        required
                        name="filterBasedOnDate{{ i }}"
                        placeholder="{{ 'reporting.custom-reports.chooseADate' | translate }}"
                        [matDatepicker]="picker"
                        (dateChange)="onDateChange($event.value, filter)"
                        #datePicker="ngModel"
                        [(ngModel)]="filter.selectedDate"
                    />
                    <mat-datepicker-toggle matSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error *ngIf="form.submitted && datePicker.hasError('required')">
                        {{ 'reporting.custom-reports.dateFilterIsRequired' | translate }}
                    </mat-error>
                </mat-form-field>

                <!-- Date picker with range -->
                <mat-form-field style="width: 100%" *ngIf="isOperatorBetween(filter)">
                    <mat-date-range-input [rangePicker]="picker">
                        <input
                            matStartDate
                            name="startDate"
                            [ngModel]="filter.selectedDateRange?.begin"
                            #filterStartDate="ngModel"
                            required
                            placeholder="{{ 'reporting.custom-reports.startDate' | translate }}"
                        />
                        <input
                            matEndDate
                            name="endDate"
                            [ngModel]="filter.selectedDateRange?.end"
                            #filterEndDate="ngModel"
                            (dateChange)="onDateRangeChange(filterStartDate.value, filterEndDate.value, filter)"
                            required
                            placeholder="{{ 'reporting.custom-reports.endDate' | translate }}"
                        />
                    </mat-date-range-input>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                    <mat-datepicker-toggle matSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                    </mat-datepicker-toggle>
                    <mat-error *ngIf="form.submitted && (filterStartDate.errors || filterEndDate.errors)">{{
                        filterStartDate.errors || filterEndDate.errors | formErrors
                    }}</mat-error>
                </mat-form-field>
            </div>
        </ng-container>

        <!-- Clear filter -->
        <div class="buttons clear-filter-button margin-top-3 columns-3 small-columns-12">
            <ui-button type="link" (click)="deleteFilter(i)">{{ 'clear' | translate }}</ui-button>
        </div>

        <!-- Added empty divs to for CSS purposes in case there are only 2/3 fields instead of 4 fields in a row-->
        <div *ngIf="showEmptyDiv(filter)" class="columns-3 small-columns-12"></div>
    </ng-container>

    <!-- Add new filter -->
    <div class="buttons add-filter-button">
        <ui-button type="link" [disabled]="isAddFilterDisabled()" (click)="addNewFilter(); $event.preventDefault()"
            ><mat-icon svgIcon="plus"></mat-icon>{{ 'reporting.custom-reports.addNewFilter' | translate }}</ui-button
        >
    </div>
</form>
